import { BackendModule } from 'i18next';

import ErrorReporter from '@lyearn/core/utils/ErrorReporter';
import retryPromise from '@lyearn/core/utils/network/retryPromise';

export const loadedNamespaces = new Set<string>();

let warnedLocaleFallback = false;

const warnLocaleFallback = (language: string) => {
  if (language !== 'en-US' && !warnedLocaleFallback) {
    warnedLocaleFallback = true;
    // eslint-disable-next-line no-console
    console.warn(
      `[@lyearn/i18n] Non-production builds bundle only en-US translations; ` +
        `'${language}' is served en-US strings. Set I18N_ALL_LOCALES=true to bundle all locales.`,
    );
  }
};

const LazyImportPlugin: BackendModule = {
  type: 'backend',
  init: function (services, backendOptions, i18nextOptions) {
    /* use services and options */
  },
  read: function (language, namespace, callback) {
    /* return resources */

    const importPromise = () =>
      process.env.NODE_ENV === 'production' ||
      (typeof process !== 'undefined' && process.env.I18N_ALL_LOCALES === 'true')
        ? import(/* webpackChunkName: "i18n/[request]" */ `../${language}/${namespace}.json`)
        : (warnLocaleFallback(language),
          import(/* webpackChunkName: "i18n/[request]" */ `../en-US/${namespace}.json`));

    retryPromise(importPromise, 3)
      .then((obj) => {
        callback(null, obj);
        loadedNamespaces.add(language + ' - ' + namespace);
      })
      .catch((err) => {
        ErrorReporter.error(err);
        callback(err, null);
      });
  },

  // only used in backends acting as cache layer
  save: function (language, namespace, data) {
    // store the translations
  },

  create: function (languages, namespace, key, fallbackValue) {
    /* save the missing translation */
  },
};

export default LazyImportPlugin;
